import App from './classes/App'
import Dom from './classes/Dom'
import Catalog from './classes/Catalog'
import Cart from './classes/Cart'
import Scroll from './classes/Scroll'

Catalog.setCatalogAddCartEvents()
Catalog.setCatalogElementEvents()